// Ported from twifi-theme-html/src/scripts/helpers/password-toggle.js
//
// Drives the show/hide-password buttons in account.twig's password-change
// form (#account-edit-password). Flips the input's type and updates
// aria-pressed/aria-label; the eye/eye-off icon swap itself is pure CSS,
// driven off the aria-pressed attribute set here (see form.less's
// .form-field__toggle[aria-pressed="true"] rule) rather than JS touching
// the icon markup directly.
// Label text comes from data-label-show/data-label-hide (set in account.twig
// via the amenities text domain) rather than being hardcoded here.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-password-toggle]').forEach((button) => {
        const input = button.closest('.form-field__control-wrap')?.querySelector('input');

        if (!input) {
            return;
        }

        button.addEventListener('click', () => {
            const show = input.type === 'password';

            input.type = show ? 'text' : 'password';
            button.setAttribute('aria-pressed', String(show));
            button.setAttribute('aria-label', show ? button.dataset.labelHide : button.dataset.labelShow);
        });
    });
});
